import { render } from "./02_ContactInfoPage.vue?vue&type=template&id=3b8f9cc8&scoped=true"
import script from "./02_ContactInfoPage.vue?vue&type=script&lang=js"
export * from "./02_ContactInfoPage.vue?vue&type=script&lang=js"

import "./02_ContactInfoPage.vue?vue&type=style&index=0&id=3b8f9cc8&lang=css"
import "./02_ContactInfoPage.vue?vue&type=style&index=1&id=3b8f9cc8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b8f9cc8"]])

export default __exports__